import React, { useEffect } from 'react';
import MaskedInput from 'react-text-mask';
import {
  Grid,
  Row,
  Col,
  FormGroup,
  FormControl,
  ControlLabel,
  HelpBlock
} from 'react-bootstrap';
import useValidation from '../../../validation/useValidation';
import {
  emailValidator,
  phoneValidator,
  requiredValidator
} from '../../../validation/validators';

const positions = [
  'Building Manager',
  'Building Supervisor',
  'Concierge',
  'Cleaner'
];

const days = [
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
  'Sunday'
];

const formatPhone = (phone) => {
  if (phone && /^\d+$/.test(phone) && phone.length === 10) {
    return `${phone.slice(0, 3)}-${phone.slice(3, 6)}-${phone.slice(
      6,
      phone.length
    )}`;
  }
  return phone;
};

export default ({ strataStaff, setStrataStaff, setValid }) => {
  const [validatePhone, phoneValid, phoneErrors] = useValidation([
    requiredValidator,
    phoneValidator
  ]);
  const [validateEmail, emailValid, emailErrors] = useValidation([
    requiredValidator,
    emailValidator
  ]);
  const [validateName, nameValid, nameErrors] = useValidation([
    requiredValidator
  ]);
  const [validatePosition, positionValid, positionErrors] = useValidation([
    requiredValidator
  ]);

  // compute validity every time a validation changes
  useEffect(() => {
    setValid(phoneValid && emailValid && nameValid && positionValid);
  }, [emailValid, nameValid, phoneValid, positionValid, setValid]);

  const onChange = (event) => {
    const { name, type, value, checked } = event.target;
    setStrataStaff((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const onBlurPhone = (event) => {
    const { name, value } = event.target;
    setStrataStaff((prev) => ({ ...prev, [name]: formatPhone(value) }));
    validatePhone(formatPhone(value));
  };

  return (
    <div>
      <section className="section m-none">
        <div>
          <Grid>
            <Row>
              <Col md={12}>
                <h3>Strata Property Staff</h3>
              </Col>
            </Row>
          </Grid>
          <Grid>
            <Row>
              <Col md={3}>
                <FormGroup validationState={positionErrors.length && 'error'}>
                  <ControlLabel>Position</ControlLabel>
                  <FormControl
                    componentClass="select"
                    placeholder="select"
                    name="position"
                    value={strataStaff.position}
                    onChange={(event) => {
                      onChange(event);
                      validatePosition(event.target.value);
                    }}
                    onBlur={(event) => validatePosition(event.target.value)}>
                    <option value="">Choose one:</option>
                    {positions.map((position) => (
                      <option value={position}>{position}</option>
                    ))}
                  </FormControl>
                  {positionErrors.map((error) => (
                    <HelpBlock key={error}>{error}</HelpBlock>
                  ))}
                </FormGroup>
              </Col>
              <Col md={3}>
                <FormGroup validationState={nameErrors.length && 'error'}>
                  <ControlLabel>Name</ControlLabel>
                  <FormControl
                    name="name"
                    type="text"
                    placeholder="Name"
                    value={strataStaff.name}
                    onChange={(event) => {
                      onChange(event);
                      validateName(event.target.value);
                    }}
                    onBlur={(event) => validateName(event.target.value)}
                  />
                  {nameErrors.map((error) => (
                    <HelpBlock key={error}>{error}</HelpBlock>
                  ))}
                </FormGroup>
              </Col>
              <Col md={3}>
                <FormGroup validationState={phoneErrors.length && 'error'}>
                  <ControlLabel>Phone</ControlLabel>
                  <FormControl
                    name="phone"
                    type="text"
                    maxLength="12"
                    placeholder="Phone"
                    value={strataStaff.phone}
                    onChange={(event) => {
                      onChange(event);
                      validatePhone(event.target.value);
                    }}
                    onBlur={onBlurPhone}
                  />
                  {phoneErrors.map((error) => (
                    <HelpBlock key={error}>{error}</HelpBlock>
                  ))}
                </FormGroup>
              </Col>
              <Col md={3}>
                <FormGroup validationState={emailErrors.length && 'error'}>
                  <ControlLabel>Email</ControlLabel>
                  <FormControl
                    name="email"
                    type="text"
                    placeholder="Email"
                    value={strataStaff.email}
                    onChange={(event) => {
                      onChange(event);
                      validateEmail(event.target.value);
                    }}
                    onBlur={(event) => validateEmail(event.target.value)}
                  />
                  {emailErrors.map((error) => (
                    <HelpBlock key={error}>{error}</HelpBlock>
                  ))}
                </FormGroup>
              </Col>
              {days.map((day) => (
                <>
                  <Col md={1}>
                    <p>{day.toUpperCase()}: </p>
                  </Col>
                  <Col md={5}>
                    <FormGroup>
                      <ControlLabel>Start Time</ControlLabel>
                      <MaskedInput
                        mask={[
                          /[0-1]/,
                          /[0-9]/,
                          ':',
                          /[0-5]/,
                          /[0-9]/,
                          /[AaPp]/,
                          /[Mm]/
                        ]}
                        name={`startTime${day}`}
                        type="text"
                        placeholder="Start"
                        value={strataStaff[`startTime${day}`]}
                        onChange={onChange}
                        className="form-control"
                      />
                      Ex: 09:00am
                    </FormGroup>
                  </Col>
                  <Col md={1} />
                  <Col md={5}>
                    <FormGroup>
                      <ControlLabel>End Time</ControlLabel>
                      <MaskedInput
                        mask={[
                          /[0-1]/,
                          /[0-9]/,
                          ':',
                          /[0-5]/,
                          /[0-9]/,
                          /[AaPp]/,
                          /[Mm]/
                        ]}
                        name={`endTime${day}`}
                        type="text"
                        placeholder="End"
                        value={strataStaff[`endTime${day}`]}
                        onChange={onChange}
                        className="form-control"
                      />
                      Ex: 05:15pm
                    </FormGroup>
                  </Col>
                </>
              ))}
            </Row>
          </Grid>
        </div>
      </section>
    </div>
  );
};
